(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2bed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2bed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lGKbD", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fca158e7bc793dc7$export$6503ec6e8aabbaf; }, function (v) { return $fca158e7bc793dc7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $fca158e7bc793dc7$export$f7ad0328861e2f03; }, function (v) { return $fca158e7bc793dc7$export$f7ad0328861e2f03 = v; });
var $fca158e7bc793dc7$export$6503ec6e8aabbaf;
var $fca158e7bc793dc7$export$f7ad0328861e2f03;
"use strict";
var $fca158e7bc793dc7$var$mapping = new Map();
function $fca158e7bc793dc7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$fca158e7bc793dc7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $fca158e7bc793dc7$var$resolve(id) {
    var resolved = $fca158e7bc793dc7$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$fca158e7bc793dc7$export$6503ec6e8aabbaf = $fca158e7bc793dc7$var$register;
$fca158e7bc793dc7$export$f7ad0328861e2f03 = $fca158e7bc793dc7$var$resolve;

});

parcelRegister("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

var $9311bda81c3ce541$exports = {};


(parcelRequire("lGKbD")).register((parcelRequire("17QCl")).getBundleURL("1DUm8"), JSON.parse('["1DUm8","index.41394ce4.js","8rSDb","kaizoft-logo-orange-login.a2bcabb1.svg","dGIUX","login-hero.4355341b.png","gesWR","html2canvas.5a3a8bd3.js","8637P","purify.433f81c6.js","4p7nV","index.es.24204389.js","1oZDq","ReactHomePageImage.8b9a78e7.svg","aWNtv","bill.4c44b088.svg","eU84k","inventory.b18c2a12.svg","lCjhT","deliveries.7b4623da.svg","6eLgl","forecast.4a749a21.svg","ek5JF","actuals.f27211e0.svg","4qZel","vendor.eb5fa21a.svg","2UNdX","filebox.f52abb1d.svg","hlikv","dots.466b3429.svg","e12cw","purchaseOrder.79434d9e.svg","3FuV2","homepageicon1.f9b2c4a4.svg","5ACo5","hp4.54840739.svg","fDOlS","calendar-mark-svgrepo-com.6ba2aed9.svg","6ZlL4","info-circle-svgrepo-com.3feee81e.svg","8BQay","index.7c1e0b01.css"]'));

})();
//# sourceMappingURL=index.runtime.7482c6ea.js.map
